// The link the hero has attached, and the chip it renders once a preview resolves.

import type { PreviewSuccess } from './errorCodes';
import { linkFallbackTitle } from './linkFallbackTitle';
import type { SocialPostPlatformId } from './platforms';
import { platformDomain } from './platforms';
import type { SocialPostClassification } from './utils';

export type AttachedPost = { platform: SocialPostPlatformId; url: string; handle: string | undefined };

export type Chip = {
	platform: SocialPostPlatformId;
	/** The source's own name when the server knows it, otherwise the platform's domain. */
	sourceLabel: string;
	/** The source's logo or favicon, when the server has one. */
	sourceLogo: string | undefined;
	handle: string | undefined;
	/** The page's title, or the link's host and path when the source gave none, so the chip always names the link. */
	title: string;
	description: string | undefined;
	image: string | undefined;
};

export function toAttachedPost(link: Extract<SocialPostClassification, { kind: 'supported_link' }>): AttachedPost {
	return { platform: link.platform, url: link.url, handle: link.handle };
}

export function toChip(post: AttachedPost | undefined, preview: PreviewSuccess | undefined): Chip | undefined {
	if (!post || !preview) return undefined;
	return {
		platform: post.platform,
		sourceLabel: preview.sourceLabel ?? platformDomain(post.platform),
		sourceLogo: preview.sourceLogo ?? undefined,
		handle: post.handle,
		title: preview.title ?? linkFallbackTitle(post.url),
		description: preview.description ?? undefined,
		image: preview.image ?? undefined,
	};
}
